var sw = require('js/lib/sw');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-color-selector]').each(function() {
    var modelId = $(this).attr('data-sw-model-material-configurator-color-selector');
    var el = this;
    require(
      [
        'vue',
        'vuex',
        'rrViewComponents/Model/MaterialConfigurator/sw-model-material-configurator-module',
        'rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorColorSelectorComponent/tpl.model-material-configurator-color-selector-vue.mustache'
      ], function (vue, vuex, modelMaterialConfiguratorModule, tpl) {
        new vue({
        el: el,
        data: {
          modelId: modelId
        },
        template: tpl.render(),
        store: modelMaterialConfiguratorModule,
        updated: function () {
          /**
           * In order to have mixpanel autohandling work
           * with vue we just call fragment loaded
           */
          this.$nextTick(function () {
            sw.trigger('sw-fragment-loaded', $(this.$el));
          });
        },
        computed: vuex.mapState({
          materialColorOptions: function (state) {
            return state[this.modelId].materialColorOptions;
          },
          hasColorSelected: function (state) {
            return state[this.modelId].hasColorSelected;
          },
          isSelectedColor: function (state) {
            return function (colorId) {
              return state[this.modelId].selectedMaterialColorId === colorId;
            }
          },
          isLoading: function(state) {
            return state[this.modelId].isLoading || false;
          }
        }),
        methods: {
          selectColor: function (colorId) {
            modelMaterialConfiguratorModule.dispatch('modelMaterialConfigurator/updateChoice', {
              modelId: this.modelId,
              hasColorSelected: true,
              selectedMaterialColorId: colorId,
              selectedMaterialFinishId: null,
              selected: 'color'
            });
          }
        }
      });
    });
  });
};
